import { NavigationState } from '@core/navigation/store/states/navigation.state';
import { ExternalLinkLoadingState } from '@core/navigation/store/states/external-link-loading.state';

export const navigationState = [NavigationState, ExternalLinkLoadingState];
